import qs from 'qs'
import refineSearchStateByLocations from '../../domain/search/refineSearchStateByLocations'

export const createBrowseUrlFromSearchStateExcludingGeo = ({
  simpleLocationName
}) => {
  const searchStateNormalized = refineSearchStateByLocations({
    simpleLocationName
  })
  return `browse/?${qs.stringify(searchStateNormalized)}`
}
